import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Fri, 09 May 2025 23:51 PM ( BRT ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.IA8rDHlaHB7_8iMfIYuoW71g7U7ruJ4TapjGXMHDYL4T2BLMW3uyzPBrDZg8iB1bvmvdlOfY_yOXA_FmuaBaB0Kb1wIzUioPIEgYmd04Eky-cqQWHX9irsZ7bcGfRT3fDIIxzVToqW92oFbU0HnKV59NZa5ogF_OUlD_3iuALXTUR8mmgNk-NSzPZNrFnnesKCBhGH7qyPZTJ6cKNA_M7VkEYyvmTszQDGVM0aSifR4Ilr6wP5z9Pof6IaB_fWUZOKvWLaepOTWi_q60KF3UvzkCKZWH0sA",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2025-05-17T02:52:13.501389Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2025-05-10T02:51:59+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.IA8rDHlaHB7_8iMfIYuoW71g7U7ruJ4TapjGXMHDYL4T2BLMW3uyzPBrDZg8iB1bvmvdlOfY_yOXA_FmuaBaB0Kb1wIzUioPIEgYmd04Eky-cqQWHX9irsZ7bcGfRT3fDIIxzVToqW92oFbU0HnKV59NZa5ogF_OUlD_3iuALXTUR8mmgNk-NSzPZNrFnnesKCBhGH7qyPZTJ6cKNA_M7VkEYyvmTszQDGVM0aSifR4Ilr6wP5z9Pof6IaB_fWUZOKvWLaepOTWi_q60KF3UvzkCKZWH0sA'

// {
//   "access_token": "v2.local.XnVuticFwSKSXB4b7MrpnsNhWECEyMdmIeo1PDG-avRhRzs1HM0ZrADtd1BZT7X0scdKOhyMomxwp2ck98Hg1QCUEuj7xuRnRuF_JhDKn8TVS2LVGCHiGKRjWeXiCtBoxuk1xqQud7m8AuMUJZZG1epJiAxAvBq-smxCdqsLdHaJjSPP3m3X1-EJAKSL567tqZfJcjMCAO2tyKyTMDVxDS1zqsUX3fdtJI9ZrPT7YDYsZhWXevAs2fAOyfcYmmqBm622Qeex-_Ox5HZytCSMczNlfemXX5E",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2025-05-17T02:53:49.328744Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2025-05-10T02:53:45+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.XnVuticFwSKSXB4b7MrpnsNhWECEyMdmIeo1PDG-avRhRzs1HM0ZrADtd1BZT7X0scdKOhyMomxwp2ck98Hg1QCUEuj7xuRnRuF_JhDKn8TVS2LVGCHiGKRjWeXiCtBoxuk1xqQud7m8AuMUJZZG1epJiAxAvBq-smxCdqsLdHaJjSPP3m3X1-EJAKSL567tqZfJcjMCAO2tyKyTMDVxDS1zqsUX3fdtJI9ZrPT7YDYsZhWXevAs2fAOyfcYmmqBm622Qeex-_Ox5HZytCSMczNlfemXX5E'

// {
//   "access_token": "v2.local.n44HqTAgEaYnvEuLZDCQQX_yfx5296WYw1S0EtQWlvycyQKjMGMxMQxmyZMgWH6K5aLl2t6eFKhEO8pwRhAP7Tb4CDDCG0psMK6wt8OUWDbNPrQLQ_41Nzpona85AYSHS4eIXLXx5Lu4vFg9zKOqBd4qkbEjNUBtoUn4GrsrN4YbQXilW3mhS3h99a_MwzeViIMznkKtXSjHTRjj0fFYURTiCuD0eqxfXhhyrt4LkIUvbJebbn9myq1nSvNcbtnFnWe8OSN-xK7g_csBLqcu0fjUlcFl",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2025-05-17T02:55:31.680080Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.n44HqTAgEaYnvEuLZDCQQX_yfx5296WYw1S0EtQWlvycyQKjMGMxMQxmyZMgWH6K5aLl2t6eFKhEO8pwRhAP7Tb4CDDCG0psMK6wt8OUWDbNPrQLQ_41Nzpona85AYSHS4eIXLXx5Lu4vFg9zKOqBd4qkbEjNUBtoUn4GrsrN4YbQXilW3mhS3h99a_MwzeViIMznkKtXSjHTRjj0fFYURTiCuD0eqxfXhhyrt4LkIUvbJebbn9myq1nSvNcbtnFnWe8OSN-xK7g_csBLqcu0fjUlcFl'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
